import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_org/organization/")({
  beforeLoad: () => {
    throw redirect({
      to: "/organization/people",
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
